import React, { KeyboardEventHandler, RefObject } from 'react';
import useTranslation from '../../hooks/useTranslation';
import styled from 'styled-components';

const PrivacyPolicyLink = styled.a`
  text-decoration: underline;
  font-weight: bold;
  display: inline;
`;

const TermsAndConditionsLabel = (
  openModalOnKeyDown: KeyboardEventHandler<HTMLAnchorElement>,
  refPrivacyLabel: RefObject<HTMLAnchorElement>,
  onChangeModal: Function
): JSX.Element => {
  /* global CSS_CONFIG */
  const formSettings = CSS_CONFIG.FORMSETTINGS;
  const { t } = useTranslation();

  const defaultTerms = (
    <>
      {CSS_CONFIG.SHOWOPPOSITELAYOUTFORCHECKBOX ? (
        <>
          {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
          <PrivacyPolicyLink
            onClick={onChangeModal(true)}
            onKeyDown={openModalOnKeyDown}
            ref={refPrivacyLabel}
            role="button"
            aria-haspopup="dialog"
            tabIndex={0}
          >
            {t('orderForm.policyAcceptLink')}
          </PrivacyPolicyLink>
          &nbsp;
          {t('orderForm.policyAcceptLabel')}
        </>
      ) : (
        <>
          {t('orderForm.policyAcceptLabel')}
          &nbsp;
          {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
          <PrivacyPolicyLink
            onClick={onChangeModal(true)}
            onKeyDown={openModalOnKeyDown}
            ref={refPrivacyLabel}
            role="button"
            aria-haspopup="dialog"
            tabIndex={0}
          >
            {t('orderForm.policyAcceptLink')}
          </PrivacyPolicyLink>
        </>
      )}
    </>
  );

  const TermsAndPolicyLinks = (
    <>
      {t('orderForm.extraPolicyLabel.extraPolicyAcceptLabelFirst')}
      &nbsp;
      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
      <PrivacyPolicyLink
        href={CSS_CONFIG.EXTRAPRIVACYPOLICYLINK}
        target="_blank"
      >
        {t('orderForm.extraPolicyLabel.extraPolicyTermsAcceptLink')}
      </PrivacyPolicyLink>
      {t('orderForm.extraPolicyLabel.extraPolicyAcceptLabelSecond')}
      <PrivacyPolicyLink
        href={CSS_CONFIG.EXTRAPRIVACYTERMSLINK}
        target="_blank"
      >
        {t('orderForm.extraPolicyLabel.extraPolicyPrivacyAcceptLink')}
      </PrivacyPolicyLink>
    </>
  );

  const TermsAndPolicyLinksWithModal = (
    <>
      {t('orderForm.extraPolicyLabel.extraPolicyAcceptLabelFirst')}
      &nbsp;
      {/* eslint-disable-next-line jsx-a11y/anchor-is-valid */}
      <PrivacyPolicyLink
        onClick={onChangeModal(true)}
        onKeyDown={openModalOnKeyDown}
        ref={refPrivacyLabel}
        role="button"
        aria-haspopup="dialog"
        tabIndex={0}
      >
        {t('orderForm.extraPolicyLabel.extraPolicyPrivacyAcceptLink')}
      </PrivacyPolicyLink>
      {t('orderForm.extraPolicyLabel.extraPolicyAcceptLabelSecond')}
      <PrivacyPolicyLink
        href={CSS_CONFIG.EXTRAPRIVACYPOLICYLINK}
        target="_blank"
      >
        {t('orderForm.extraPolicyLabel.extraPolicyTermsAcceptLink')}
      </PrivacyPolicyLink>
    </>
  );

  const chooseLabel = (): JSX.Element => {
    if (formSettings.showExtraPrivacyPolicyAndTermsTexts) {
      return TermsAndPolicyLinks;
    }
    if (formSettings.showExtraPrivacyPolicyAndTermsTextsWithModal) {
      return TermsAndPolicyLinksWithModal;
    }
    return defaultTerms;
  };

  return <>{chooseLabel()}</>;
};

export default TermsAndConditionsLabel;
